import stbAPIGateway from '../../../../services/stbAPIGateway';

export const postCsvExternalIdpSaml = async ({ rootGetters }, { clientSid, samlIdpInfo }) => {
  const axios = rootGetters['app/stbAxios'];

  const stbApi = stbAPIGateway(axios, process.env.API_URL);

  const result = await stbApi.postHubCsvExternalIdpSaml(clientSid, samlIdpInfo);
  return result;
};
